import React, { useEffect, useState } from "react";
import axiosInstance from "../../api/axiosInstance"; // adjust the path as needed
import Popup from "../../components/client/Popup";

const AccountCard = () => {
  const [account, setAccount] = useState(null);
  const [popup, setPopup] = useState(null);

  useEffect(() => {
    const fetchAccount = async () => {
      try {
        const res = await axiosInstance.get("/auth/me/");
        setAccount(res.data);
      } catch (err) {
        setPopup({ message: "Failed to load user info", type: "error" });
      }
    };
    fetchAccount();
  }, []);

  return (
    <div
      className="
        relative rounded-2xl p-6 overflow-hidden text-sm font-sans
        bg-white text-gray-800 shadow-md ring-1 ring-black/5
        dark:bg-black/30 dark:text-gray-300 dark:backdrop-blur-lg
        dark:border dark:border-gray-700 dark:shadow-xl dark:ring-0
      "
    >
      <h4
        className="
          text-2xl font-bold mb-6 tracking-wide font-fantasy
          text-gray-900 dark:text-indigo-400 drop-shadow-md
        "
      >
        👤 Account Overview
      </h4>

      <div className="space-y-5">
        <Info label="Email" value={account?.email || "Loading..."} />

        <Info
          label="2FA"
          value={
            <span
              className={`px-3 py-1 rounded-full text-xs font-mono border
                ${
                  account?.two_factor_enabled
                    ? "bg-green-100 text-green-700 border-green-400 dark:bg-green-900 dark:text-green-400 dark:border-green-600"
                    : "bg-yellow-100 text-yellow-700 border-yellow-400 dark:bg-yellow-900 dark:text-yellow-400 dark:border-yellow-600"
                }`}
            >
              {account
                ? account.two_factor_enabled
                  ? "On"
                  : "Off"
                : "Loading..."}
            </span>
          }
        />

        <Info
          label="Last Login"
          value={
            account
              ? new Date(account.last_login).toLocaleString("en-US")
              : "Loading..."
          }
        />

        <Info label="Timezone" value={account?.timezone || "UTC"} />
      </div>

      {popup && (
        <div className="mt-4">
          <Popup
            message={popup.message}
            type={popup.type}
            onClose={() => setPopup(null)}
          />
        </div>
      )}
    </div>
  );
};

const Info = ({ label, value }) => (
  <div className="flex justify-between items-center">
    <span className="font-semibold text-gray-600 dark:text-gray-400">
      {label}
    </span>
    <span className="text-right text-xs font-mono text-gray-800 dark:text-gray-300 max-w-[200px] truncate">
      {value}
    </span>
  </div>
);

export default AccountCard;
